import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useState, useCallback, useMemo } from 'react';
import { Text } from '../Text/Text.es.js';
import { StarFilled, StarHalfFilled, StarOutlined, StarRating as StarRating$1 } from './styled.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var StarRating = function StarRating(_a) {
  var _b = _a,
      _b$currentRating = _b.currentRating,
      currentRating = _b$currentRating === void 0 ? 0 : _b$currentRating,
      _b$maxRating = _b.maxRating,
      maxRating = _b$maxRating === void 0 ? 5 : _b$maxRating,
      _b$isActive = _b.isActive,
      isActive = _b$isActive === void 0 ? false : _b$isActive,
      onClick = _b.onClick,
      _b$type = _b.type,
      type = _b$type === void 0 ? "default" : _b$type,
      _b$size = _b.size,
      size = _b$size === void 0 ? "md" : _b$size,
      _b$variant = _b.variant,
      variant = _b$variant === void 0 ? "default" : _b$variant,
      rest = __objRest(_b, ["currentRating", "maxRating", "isActive", "onClick", "type", "size", "variant"]);

  var _useState = useState(-1),
      hoveredElIndex = _useState[0],
      hover = _useState[1];

  var onClickHandler = useCallback(function (rating) {
    return function () {
      if (isActive) {
        onClick && onClick(rating);
      }
    };
  }, [isActive, onClick]);
  var onHoverHandler = useCallback(function (index) {
    return function () {
      if (isActive) {
        hover(index);
      }
    };
  }, [hover, isActive]);
  var textSize = useMemo(function () {
    switch (size) {
      case "sm":
        return "xs";

      case "md":
        return "sm";

      case "lg":
        return "md";

      default:
        return "sm";
    }
  }, [size]);
  var defaultRating = useMemo(function () {
    return Array.from({
      length: maxRating
    }).map(function (_val, index) {
      if (hoveredElIndex === -1) {
        if (index + 1 <= currentRating) {
          return (
            /* @__PURE__ */
            React.createElement(StarFilled, {
              variant: variant,
              size: size,
              key: index,
              onMouseEnter: onHoverHandler(index),
              onClick: onClickHandler(index + 1),
              onTouchStart: onClickHandler(index + 1)
            })
          );
        }

        if (Number(index + ".26") <= currentRating && Number(index + ".75") >= currentRating) {
          return (
            /* @__PURE__ */
            React.createElement(StarHalfFilled, {
              variant: variant,
              size: size,
              key: index,
              onMouseEnter: onHoverHandler(index),
              onClick: onClickHandler(index + 1),
              onTouchStart: onClickHandler(index + 1)
            })
          );
        }
      } else {
        if (hoveredElIndex >= index) {
          return (
            /* @__PURE__ */
            React.createElement(StarFilled, {
              variant: variant,
              size: size,
              key: index,
              onMouseEnter: onHoverHandler(index),
              onMouseLeave: onHoverHandler(-1),
              onClick: onClickHandler(index + 1),
              onTouchStart: onClickHandler(index + 1)
            })
          );
        }
      }

      return (
        /* @__PURE__ */
        React.createElement(StarOutlined, {
          variant: variant,
          size: size,
          key: index,
          onMouseEnter: onHoverHandler(index),
          onClick: onClickHandler(index + 1),
          onTouchStart: onClickHandler(index + 1)
        })
      );
    });
  }, [maxRating, hoveredElIndex, variant, size, onHoverHandler, currentRating, onClickHandler]);
  var numericRating = useMemo(function () {
    return (
      /* @__PURE__ */
      React.createElement(React.Fragment, null,
      /* @__PURE__ */
      React.createElement(Text, {
        size: textSize,
        fontWeight: "bold"
      }, currentRating),
      /* @__PURE__ */
      React.createElement(StarFilled, {
        size: size,
        variant: variant
      }))
    );
  }, [currentRating, variant, size, textSize]);
  return (
    /* @__PURE__ */
    React.createElement(StarRating$1, __spreadValues({
      isActive: isActive,
      variant: variant,
      type: type
    }, rest), type === "numeric" ? numericRating : defaultRating)
  );
};

StarRating.displayName = "StarRating";
export { StarRating };